import { create } from 'zustand'

export const useToastStore = create((set) => ({
  toasts: [],
  addToast: (toast) => {
    const id = Date.now() + Math.random()
    const newToast = { 
      id, 
      title: toast.title || (toast.type === 'error' ? 'Error' : 'Notification'),
      description: toast.description,
      type: toast.type || 'info', // 'success' | 'error' | 'info' | 'warning'
      duration: toast.duration || 5000
    }
    
    set((state) => ({ 
      toasts: [...state.toasts, newToast] 
    }))

    // Auto-remove toast after duration
    if (newToast.duration !== Infinity) {
      setTimeout(() => {
        set((state) => ({
          toasts: state.toasts.filter((t) => t.id !== id)
        }))
      }, newToast.duration)
    }
  },
  removeToast: (id) => set((state) => ({
    toasts: state.toasts.filter((t) => t.id !== id)
  }))
}))

export const toast = {
  success: (description, title) => useToastStore.getState().addToast({ type: 'success', title, description }),
  error: (description, title) => useToastStore.getState().addToast({ type: 'error', title, description }),
  info: (description, title) => useToastStore.getState().addToast({ type: 'info', title, description }),
  warning: (description, title) => useToastStore.getState().addToast({ type: 'warning', title, description }),
}
